// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading{text-align:center;max-width:40rem;margin-bottom:2rem;margin-top:2rem}", ""]);
// Exports
module.exports = exports;
